export default {
  baseStyle: {
    indicator: {
      '&[data-status=active]': {
        borderColor: 'primary.solid',
      },
      '&[data-status=complete]': {
        bg: 'primary.solid',
      },
    },
    separator: {
      '&[data-status=complete]': {
        bg: 'primary.solid',
      },
    },
  },
}
